/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamRevisionBotexamidQueryResponse,
  GetApiV1ExamRevisionBotexamidPathParams,
  GetApiV1ExamRevisionBotexamidQueryParams,
  GetApiV1ExamRevisionBotexamid400,
  GetApiV1ExamRevisionBotexamid401,
  GetApiV1ExamRevisionBotexamid404,
  GetApiV1ExamRevisionBotexamid500,
} from "../../types/examRevisionController/GetApiV1ExamRevisionBotexamid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamRevisionBotexamid } from "../../clients/examRevisionController/getApiV1ExamRevisionBotexamid.ts";

export const getApiV1ExamRevisionBotexamidQueryKey = (
  botExamId: GetApiV1ExamRevisionBotexamidPathParams["botExamId"],
  params?: GetApiV1ExamRevisionBotexamidQueryParams,
) =>
  [
    {
      url: "/api/v1/exam/revision/:botExamId",
      params: { botExamId: botExamId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamRevisionBotexamidQueryKey = ReturnType<
  typeof getApiV1ExamRevisionBotexamidQueryKey
>;

export function getApiV1ExamRevisionBotexamidQueryOptions(
  botExamId: GetApiV1ExamRevisionBotexamidPathParams["botExamId"],
  params?: GetApiV1ExamRevisionBotexamidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamRevisionBotexamidQueryKey(botExamId, params);
  return queryOptions<
    GetApiV1ExamRevisionBotexamidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionBotexamid400
      | GetApiV1ExamRevisionBotexamid401
      | GetApiV1ExamRevisionBotexamid404
      | GetApiV1ExamRevisionBotexamid500
    >,
    GetApiV1ExamRevisionBotexamidQueryResponse,
    typeof queryKey
  >({
    enabled: !!botExamId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamRevisionBotexamid(botExamId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados da versão em português (pt-BR) de uma prova gerada por IA, incluindo título, instrução e a página de questões com suas opções, para exibição na tela de revisão. A paginação é feita por questão. **(Requer Authorization para autenticação)**
 * @summary Carregar dados de revisão da prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/:botExamId}
 */
export function useGetApiV1ExamRevisionBotexamid<
  TData = GetApiV1ExamRevisionBotexamidQueryResponse,
  TQueryData = GetApiV1ExamRevisionBotexamidQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamRevisionBotexamidQueryKey,
>(
  botExamId: GetApiV1ExamRevisionBotexamidPathParams["botExamId"],
  params?: GetApiV1ExamRevisionBotexamidQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamRevisionBotexamidQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamRevisionBotexamid400
          | GetApiV1ExamRevisionBotexamid401
          | GetApiV1ExamRevisionBotexamid404
          | GetApiV1ExamRevisionBotexamid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamRevisionBotexamidQueryKey(botExamId, params);

  const query = useQuery(
    {
      ...getApiV1ExamRevisionBotexamidQueryOptions(botExamId, params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionBotexamid400
      | GetApiV1ExamRevisionBotexamid401
      | GetApiV1ExamRevisionBotexamid404
      | GetApiV1ExamRevisionBotexamid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
